export const columns = [
  {
    type: 'index',
    label: '序号',
    width: '55'
  },
  {
    prop: 'content',
    label: '内容',
    align: 'left',
    headerAlign: 'center'
  },
  {
    prop: 'issueDate',
    label: '发布时间',
    width: '300'
  },
  {
    label: '操作',
    slotName: 'default',
    width: '200',
    fixed: 'right'
  }
];
